import { fromJS, List, Map } from 'immutable'
import _ from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { v4 as uuid } from 'uuid'
import { resetCart } from '../store/project/cart'
import { processButtonAction } from '../store/project/processButtonAction'

export const catalogBuilderData = _.times(32, (n) => {
  const discountPrice = Math.round(Math.random() * 1000000) / 100
  let isSold = Math.random() > 0.5
  let isOnSale = !isSold && Math.random() > 0.5
  let customTag = !isOnSale && Math.random() > 0.5 ? 'Custom' : null
  return {
    value: n,
    name: 'Product name - Color',
    image: '',
    price: discountPrice,
    discountPrice: Math.round(Math.random() * discountPrice * 100) / 100,
    isSold,
    isOnSale,
    customTag,
  }
})

export const defaultFieldsList = [
  {
    type: '',
    label: `Description`,
    referenceTo: null,
    relationshipName: null,
    id: uuid(),
  },
  {
    type: '',
    label: `Shipping Info`,
    referenceTo: null,
    relationshipName: null,
    id: uuid(),
  },
  {
    type: '',
    label: `Specs`,
    referenceTo: null,
    relationshipName: null,
    id: uuid(),
  },
  {
    type: '',
    label: `Returns`,
    referenceTo: null,
    relationshipName: null,
    id: uuid(),
  },
]

export const useECommercePageCaptions = () =>
  useSelector((state) => state.getIn(['project', 'Settings', 'eCommerce', 'captions'], Map()))

export const getIsProductInCart = (value) => (state) =>
  state.getIn(['state', 'eCommerce', 'e_cart'], List()).findIndex((item) => item.get('value') === value) !== -1

export const useSelectedProductID = () => useSelector((state) => state.getIn(['state', 'eCommerce', 'product'], ''))

export function useECommerceCurrencySymbol(isPreview = true) {
  let settings = useSelector((state) =>
    state.getIn(
      isPreview
        ? ['project', 'Settings', 'eCommerce', 'payment']
        : ['project', 'Settings', 'eCommerce', 'private', 'payment'],
      Map()
    )
  )
  let sett

  let useFormat = useSelector((state) => state.getIn(['project', 'Settings', 'eCommerce', 'usePriceFormat'], false))
  let priceFormat = useSelector((state) => state.getIn(['project', 'Settings', 'eCommerce', 'priceFormat'], Map()))

  if (useFormat) {
    if (priceFormat.getIn(['meta', 'prefix']) || priceFormat.getIn(['meta', 'postfix'])) {
      return ''
    }
  }

  settings.map((row) => {
    if (!sett && row.get('currency')) {
      sett = row
    }
  })

  if (!sett) {
    return '$'
  }

  let currencySymbol = sett.getIn(['currency', 'symbol'], '')
  let currency = sett.getIn(['currency', 'value'], '')
  let customCurrency = sett.getIn(['customCurrency'], '')

  if (!isPreview) {
    if (currency == 'other') {
      return '$ '
    } else {
      return (currencySymbol || currency) + ' '
    }
  }

  let dynamicCurrency = useSelector((state) => state.getIn(['params', customCurrency]))
  if (currency == 'other' && dynamicCurrency) {
    return dynamicCurrency + ' '
  } else if (currency == 'other') {
    return '$ '
  }

  return (currencySymbol || currency) + ' '
}

export function useTaxPercent(isPreview = true) {
  if (!isPreview) {
    return 0.15
  }
  const percent = useSelector((state) => state.getIn(['state', 'eCommerce', 'e_checkout - tax', 'percent'], 0))
  let floatPercent = parseFloat(percent)
  if (_.isNaN(floatPercent)) {
    floatPercent = 0
  }
  return floatPercent
}

export function getValueByKey(state, key) {
  if (!key) {
    return ''
  }
  let pricePath = 'state'
  if (String(key).indexOf(':') == -1) {
    pricePath = 'params'
  }
  let val = state.getIn([pricePath, ...String(key).split(':')])

  return val
}
export function useCustomTotalPrice(isPreview = true, customServiceSettings) {
  if (!isPreview || !customServiceSettings) {
    return {
      price: 0,
    }
  }
  let nameUID = customServiceSettings.get('productName')
  let priceUID = customServiceSettings.get('totalAmount')

  if (!priceUID) {
    return {
      price: 0,
    }
  }
  let pricePath = 'state',
    namePath = 'state'
  if (String(priceUID).indexOf(':') == -1) {
    pricePath = 'params'
  }
  if (String(nameUID).indexOf(':') == -1) {
    namePath = 'params'
  }
  let price = useSelector((state) => state.getIn([pricePath, ...String(priceUID).split(':')], 0))
  let label = ''
  if (nameUID) {
    label = useSelector((state) => state.getIn([namePath, ...String(nameUID).split(':')], ''))
  }

  price = parseFloat(price)
  if (isNaN(price)) {
    price = 0
  }

  return {
    price,
    name: label,
  }
}

export const processCashCallback = () => async (dispatch, getState) => {
  let state = getState()
  let settings = state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Cash'])
  let pushMapping = state.getIn(['project', 'Settings', 'pushToSalesforce'])

  if (!settings) {
    return false
  }

  if (settings.get('sendEmail')) {
    dispatch(
      processButtonAction(
        fromJS([
          {
            uid: 'e_stripe',
            conditions: [],
            isAction: false,
            actions: {
              sendEmail: {
                0: {
                  enabled: true,
                  selected: settings.get('sendEmail'),
                },
              },
            },
          },
        ])
      )
    )
  }

  let actionsList = []
  if (pushMapping) {
    pushMapping.map((sfItem) => {
      if (sfItem.get('isUponPayment')) {
        actionsList.push({
          value: sfItem.get('uid'),
          isPush: true,
        })
      }
    })
  }

  if (actionsList.length) {
    const homePage = state.getIn(['project', 'Pages'], List()).find((page) => page.get('isHome'))
    dispatch(
      processButtonAction(
        fromJS([
          {
            uid: 'e_stripe_payment',
            conditions: [],
            isAction: false,
            actions: {
              sfAction: [
                {
                  items: actionsList,
                },
              ],
            },
          },
          {
            uid: 'e_stripe_payment',
            conditions: [],
            isAction: false,
            actions: {
              ElemInteractivity: { 0: { enabled: true } },
              cartInteractivity: { 0: { enabled: true, action: 'Reset Cart' } },
            },
          },
          {
            uid: 'e_stripe_payment',
            conditions: [],
            isAction: false,
            actions: {
              redirect: [
                {
                  typeOfRedirect: 'Internal',
                  enabled: true,
                  redirect: {
                    ftMode: 'Internal',
                    type: 'page',
                    value: homePage.get('uid'),
                  },
                },
              ],
            },
          },
        ])
      )
    )
  } else {
    setTimeout(function () {
      dispatch(resetCart())

      if (
        settings.get('redirectOnSuccess') &&
        settings.get('redirectOnSuccess').size &&
        settings.get('isRedirectOnSuccess')
      ) {
        dispatch(
          processButtonAction(
            fromJS([
              {
                uid: uuid(),
                conditions: [],
                isAction: false,
                actions: {
                  redirect: [
                    {
                      enabled: true,
                      ...settings.get('redirectOnSuccess').toJS(),
                    },
                  ],
                },
              },
            ]),
            'eCommerce',
            false,
            null
          )
        )
      } else {
        const homePage = state.getIn(['project', 'Pages'], List()).find((page) => page.get('isHome'))
        if (homePage) {
          window.__FT_PROJECT__API__.goToPage(homePage.get('_id'), '', true)
        }
      }
    }, 1500)
  }
}

export function useTaxValue(isPreview = true) {
  if (!isPreview) {
    return 0
  }
  const percent = useSelector((state) => state.getIn(['state', 'eCommerce', 'e_checkout - tax', 'value'], 0))
  let floatPercent = parseFloat(percent)
  if (_.isNaN(floatPercent)) {
    floatPercent = 0
  }
  if (floatPercent > 1) {
    floatPercent = floatPercent / 100
  }
  return floatPercent
}

export function useCountryOptions(key, isPreview = true, key2 = 'country') {
  const metaOptions = useSelector((state) => state.getIn(['meta', 'eCommerce', 'e_checkout', key, key2], Map()))

  const options = useMemo(() => {
    let options = []

    const metaJS = metaOptions.toJS()
    if (_.isArray(metaJS)) {
      _.each(metaJS, (val) => {
        if (val) {
          options.push({
            value: val.value,
            label: val.label,
          })
        }
      })
    } else {
      _.each(_.keys(metaJS), (key) => {
        _.each(metaJS[key], (val) => {
          if (val) {
            options.push({
              value: val.value,
              label: val.label,
            })
          }
        })
      })
    }

    return options
  }, [metaOptions])

  return isPreview
    ? options
    : [
        {
          value: 'India',
          label: 'India',
        },
        {
          value: 'USA',
          label: 'USA',
        },
        {
          value: 'Mexico',
          label: 'Mexico',
        },
      ]
}

export function useECommerceValue(path = [], defValue = null) {
  return useSelector((state) => state.getIn(['project', 'Settings', 'eCommerce', ...path], defValue))
}

export function useShippingMethods(isPreview = true) {
  if (!isPreview) {
    return fromJS([
      {
        type: 'static',
        method: 'Standard Shipping',
        price: 'FREE',
        days: '8-15 Business Days',
        arrivalDate: ' Arrives between Dec 1 - Dec 8',
        id: 'e7502de8-b384-4aaa-9794-c788caf7840b',
      },
      {
        type: 'static',
        method: 'Express Shipping',
        price: '$10.00',
        days: '4-6 Business Days',
        arrivalDate: 'Arrives between Nov 24 - Nov 26',
        id: '3ea21790-4315-41a3-a621-dc93ea1c1fa6',
      },
      {
        type: 'static',
        method: 'Overnight Shipping',
        price: '$50.00',
        days: '1 Business Day',
        arrivalDate: 'Arrives Nov 21',
        id: '3ea21790-4315-41a3-a621-dc93ea1c1fa6',
      },
    ])
  }
  const disabledShippingMethods = useSelector((state) =>
    state
      .getIn(['project', 'Settings', 'eCommerce', 'shippingList'], List())
      .filter((val) => val.get('disabled', false) === true)
      .map((val) => val.get('id'))
  )
  const disabledShippingMethodsJS = disabledShippingMethods.toJS()
  let shippingMethods = useSelector((state) =>
    state
      .getIn(['project', 'Settings', 'eCommerce', 'shippingList'], List())
      .filter((val) => val.get('disabled', false) !== true)
  )
  const bringShippingMethods = useSelector((state) => state.getIn(['state', 'eCommerce', 'e_shipping'], List()).toJS())

  _.each(bringShippingMethods, function (shipping, shippingKey) {
    if (shipping && shipping.value && _.isArray(shipping.value)) {
      _.each(shipping.ftGuid, (val, index) => {
        if (!disabledShippingMethodsJS.includes(shippingKey)) {
          shippingMethods = shippingMethods.push(
            fromJS({
              type: 'static',
              method: _.get(shipping, ['nameOfMethod', index]),
              price: _.get(shipping, ['shippingPrice', index]),
              days: _.get(shipping, ['businessDays', index]),
              arrivalDate: _.get(shipping, ['arrivalDate', index]),
              id: _.get(shipping, ['value', index]),
            })
          )
        }
      })
    } else if (!disabledShippingMethodsJS.includes(shippingKey)) {
      shippingMethods = shippingMethods.push(
        fromJS({
          type: 'static',
          method: shipping.nameOfMethod,
          price: shipping.shippingPrice,
          days: shipping.businessDays,
          arrivalDate: shipping.arrivalDate,
          id: shipping.value,
        })
      )
    }
  })

  return shippingMethods
}
export function useCouponState(isPreview = true) {
  if (!isPreview) {
    return Map({
      value: 'code',
      discountNum: 123.33,
      percent: null,
    })
  }
  const e_coupon = useSelector((state) => state.getIn(['state', 'eCommerce', 'e_coupon'], Map()))
  return e_coupon
}

export function useProductOptionsList(isPreview = true) {
  const productAttr = useECommerceValue(['pages', 'e_product', 'Props', 'productAttr'], List())
  const metaOptions = useSelector((state) => state.getIn(['meta', 'eCommerce', 'e_product'], Map()))
  const eProduct = useSelector((state) => state.getIn(['state', 'e_product'], Map()))

  const options = useMemo(() => {
    let options = []
    productAttr.map((attr, index) => {
      if (attr.getIn(['Props', 'source'], 'object') == 'pick_list') {
        const metaJS = _.omitBy(metaOptions.toJS(), (v, k) => k !== `attr${index}`)
        _.each(_.keys(metaJS), (key) => {
          let rows = [{ value: '', label: 'Select' }]
          _.each(metaJS[key], (val) => {
            rows.push({
              value: val.value,
              label: val.label,
            })
          })

          options.push(rows)
        })
      } else {
        const stateJS = eProduct.getIn([`attr${index}`], Map()).toJS()
        let data = [{ value: '', label: 'Select' }]
        const size = _.size(_.max(_.filter(_.values(stateJS), _.isArray)))
        if (size > 0) {
          const keys = _.keys(stateJS)
          _.times(size, (index) => {
            let row = _.reduce(
              keys,
              (r, v) => {
                let val = _.get(stateJS, [v], null)
                if (_.isArray(val)) {
                  val = _.get(val, index, null)
                }
                return {
                  ...r,
                  [v]: val,
                }
              },
              {}
            )
            row.attr = []
            _.each(_.keys(stateJS.attr), (attrIndex) => {
              let val = _.get(stateJS, ['attr', attrIndex], null)
              if (_.isArray(val)) {
                val = _.get(val, index, null)
              }
              let attr = _.find(attrJS, (atr) => atr.value === val)
              if (attr) {
                row.attr[attrIndex] = attr
              } else {
                row.attr[attrIndex] = { value: val, label: val }
              }
            })
            if (_.size(row) > 0) {
              data.push(row)
            }
          })
        }
        options.push(data)
      }
    })

    return options
  }, [metaOptions, productAttr, eProduct])

  return isPreview
    ? options
    : new Array(4).fill([
        { value: '', label: 'Select' },
        { value: 'white', label: 'White' },
        { value: 'red', label: 'Red' },
        { value: 'blue', label: 'Blue' },
      ])
}

export const getCartProductsHash = (state) => {
  let cartList = state.getIn(['state', 'eCommerce', 'e_cart'], List())
  cartList = cartList.map((row) => {
    let price = parseFloat(row.get('price', 0))
    if (isNaN(price)) {
      price = 0
    }
    let discountPrice = parseFloat(row.get('discountPrice', 0))
    if (isNaN(discountPrice)) {
      discountPrice = 0
    }

    if (row.get('discountPrice')) {
      row = row.set('salePrice', discountPrice)
      row = row.set('discountPrice', discountPrice)
    } else {
      row = row.set('salePrice', price)
    }
    row = row.set('price', price)
    return row
  })
  const hash = {}
  cartList.map((product) => {
    let id = product.get('value')
    hash[id] = hash[id] ?? 0
    hash[id] += parseInt(product.get('count', 0))
    product.get('addons', List()).map((addon) => {
      let id = addon.get('Id')
      hash[id] = hash[id] ?? 0
      hash[id] += parseInt(addon.get('count', 0))
    })
  })
  return hash
}

export const useCartProductsCountHash = (isPreview = true) => {
  const cartData = useCartData(isPreview)
  return useMemo(() => {
    const hash = {}
    cartData.map((product) => {
      let id = product.get('value')
      hash[id] = hash[id] ?? 0
      hash[id] += parseInt(product.get('count', 0))
      product.get('addons', List()).map((addon) => {
        let id = addon.get('Id')
        hash[id] = hash[id] ?? 0
        hash[id] += parseInt(addon.get('count', 0))
      })
    })
    return hash
  }, [cartData])
}

export function useCartData(isPreview = true) {
  if (!isPreview) {
    return fromJS(catalogBuilderData.slice(0, 4))
  }
  const cartList = useSelector((state) => state.getIn(['state', 'eCommerce', 'e_cart'], List()))

  return useMemo(
    () =>
      cartList.map((row) => {
        let price = parseFloat(row.get('price', 0))
        if (isNaN(price)) {
          price = 0
        }
        let discountPrice = parseFloat(row.get('discountPrice', 0))
        if (isNaN(discountPrice)) {
          discountPrice = 0
        }

        // row.get('attr', List()).map(attr => {
        //     if (attr && attr.get('price')) {
        //         let delta = parseFloat(attr.get('price'));
        //         if (!isNaN(delta)) {
        //             price += delta;

        //             if (row.get('discountPrice')) {
        //                 discountPrice += delta;
        //             }
        //         }
        //     }
        // })

        if (row.get('discountPrice')) {
          row = row.set('salePrice', discountPrice)
          row = row.set('discountPrice', discountPrice)
        } else {
          row = row.set('salePrice', price)
        }
        row = row.set('price', price)
        return row
      }),
    [cartList]
  )
}

export function useECommerceCatalogData(isPreview = true) {
  if (!isPreview) {
    return catalogBuilderData
  }
  const productAttr = useECommerceValue(['pages', 'e_product', 'Props', 'productAttr'], List())
  const catalogState = useSelector((state) => state.getIn(['state', 'eCommerce', 'eProductList'], Map()))
  const previewData = useMemo(() => {
    const stateJS = catalogState.toJS()
    const attrJS = productAttr.toJS()
    let data = []
    const size = _.size(_.max(_.filter(_.values(stateJS), _.isArray)))
    if (size > 0) {
      const keys = _.keys(stateJS)
      _.times(size, (index) => {
        let row = _.reduce(
          keys,
          (r, v) => {
            let val = _.get(stateJS, [v], null)
            if (_.isArray(val)) {
              val = _.get(val, index, null)
            }
            return {
              ...r,
              [v]: val,
            }
          },
          {}
        )
        row.attr = []
        _.each(_.keys(stateJS.attr), (attrIndex) => {
          let val = _.get(stateJS, ['attr', attrIndex], null)
          if (_.isArray(val)) {
            val = _.get(val, index, null)
          }
          let attr = _.find(attrJS, (atr) => atr.value === val)
          if (attr) {
            row.attr[attrIndex] = attr
          } else {
            row.attr[attrIndex] = { value: val, label: val }
          }
        })
        row.var = {}
        _.each(_.keys(stateJS.var), (attrIndex) => {
          let val = _.get(stateJS, ['var', attrIndex], null)
          if (_.isArray(val)) {
            val = _.get(val, index, null)
          }
          row.var[attrIndex] = val
        })
        if (_.size(row) > 0) {
          data.push(row)
        }
      })
    }
    return _.filter(data, (row) => {
      return row.value
    })
  }, [catalogState, productAttr])
  return previewData
}

export function getTotalPrice(details) {
  let sum = 0
  _.each(details.cartList, (row) => {
    let price
    let count = parseInt(row.count)
    if (count < 0) {
      count = 0
    }
    if (row.discountPrice > 0) {
      price = parseFloat(row.discountPrice)
    } else {
      price = parseFloat(row.price)
    }
    if (isNaN(price)) {
      price = 0
    }
    let addonTotal = _.reduce(
      row.addons || [],
      (r, addon) => {
        let addonPrice = 0
        let addonCount = parseInt(addon?.count, 10)
        if (Number.isNaN(addonCount)) {
          addonCount = 0
        }
        if (addon?.discountPrice) {
          let num = parseFloat(addon?.discountPrice)
          if (!Number.isNaN(num)) {
            addonPrice = num
          }
        } else {
          let num = parseFloat(addon?.price || 0)
          if (!_.isNaN(num)) {
            addonPrice = num
          }
        }
        return r + addonPrice * addonCount
      },
      0
    )
    sum += price * count + addonTotal
  })

  if (details.isUseShippingMethods) {
    let shippingPrice = parseFloat(_.get(details, ['currentShippingMethod', 'price']))
    if (!isNaN(shippingPrice)) {
      sum += shippingPrice
    }
  }

  if (details.isEnabledCoupon && details.couponState) {
    if (details.couponState.discountNum) {
      let discountAmount = parseFloat(details.couponState.discountNum)
      if (!isNaN(discountAmount)) {
        sum -= discountAmount
      }
    } else if (details.couponState.discountPercent) {
      let percent = parseFloat(details.couponState.discountPercent)
      if (!isNaN(percent)) {
        let discountAmount = sum * (percent / 100)
        if (!isNaN(percent)) {
          sum -= discountAmount
        }
      }
    }
  }

  if (details.taxPercent) {
    const taxtPerc = parseFloat(details.taxPercent)
    if (!isNaN(taxtPerc)) {
      let tax = sum * taxtPerc
      sum += tax
    }
  } else if (details.taxValue) {
    sum += parseInt(details.taxValue)
  }

  if (isNaN(sum) || sum < 0) {
    sum = 0
  }

  return sum
}
